import { createSlice } from "@reduxjs/toolkit";
import {
  EntityStatus,
  TeamSubscriptionTiers,
  UserRole,
  UserType,
} from "enums/account";
import { MemberStatus } from "pages/login/enums/user";
import { Delegates } from "enums/account";
import { PaymentProvider } from "types/main";

interface MemberEntity {
  id: string;
  name: string;
  avatar: string;
  status: MemberStatus;
  entity_status: EntityStatus;
  role: UserRole;
  privileges: Delegates[];
  isSelected: boolean;
  subscription: Subscription;
}

interface Subscription {
  account_type: UserType;
  tier: TeamSubscriptionTiers;
  expiration_date: string;
  payment_term: string;
  payment_provider: PaymentProvider;
  is_activated: string;
}

interface AppData {
  token: string;
  memberId: string;
  entityId: string;
  avatar: string;
  email: string;
  last_name: string;
  first_name: string;
  entities_info: MemberEntity[];
}

interface AppState {
  allData: AppData;
}

const initialState: AppState = {
  allData: JSON.parse(localStorage.getItem("appData") || "{}") || {
    token: "",
    avatar: "",
    memberId: "",
    entityId: "",
    primary_entity: "",
    email: "",
    last_name: "",
    first_name: "",
    entities_info: [
      {
        subscription: {
          account_type: "",
          tier: "",
          expiration_date: "",
          payment_term: "",
          payment_provider: "",
          is_activated: "",
        },
      },
    ],
  },
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAppData(state, action) {
      const {
        avatar = "",
        token = "",
        memberId = "",
        entityId = "",
        primary_entity = "",
        email = "",
        first_name = "",
        last_name = "",
        entities_info = [],
      } = action.payload.data || {};

      const updatedData = {
        avatar,
        token,
        memberId,
        email,
        first_name,
        last_name,
        entityId,
        primary_entity,
        entities_info: (entities_info || []).map((entity: MemberEntity) => ({
          ...entity,
          isSelected: entity.id === entityId,
        })),
      };

      state.allData = updatedData;
      console.log(updatedData);
      localStorage.setItem("appData", JSON.stringify(updatedData));
    },
    clearAppData(state) {
      state.allData = {
        token: "",
        avatar: "",
        memberId: "",
        entityId: "",
        email: "",
        last_name: "",
        first_name: "",
        entities_info: [],
      };
      localStorage.removeItem("appData");
    },

    updateEntityName(state, action) {
      const { entityId, newName } = action.payload;

      // state.allData.entity_name = newName;

      state.allData.entities_info = state.allData.entities_info.map(
        (entity: MemberEntity) => {
          if (entity.id === entityId) {
            return {
              ...entity,
              name: newName,
            };
          }
          return entity;
        }
      );

      localStorage.setItem("appData", JSON.stringify(state.allData));
    },
  },
});

export const { setAppData, clearAppData, updateEntityName } = appSlice.actions;
export const appActions = appSlice.actions;

export default appSlice.reducer;
